import { useState, useContext } from 'react'
import { LoginContext } from '../context/loginContext'
import Login from '../login/Login'
import MensajeConexion from '../mensajeConexion/MensajeConexion'
import MenuFiltros from '../MenuFiltros'
import ContenedorTiendas from './ContenedorTiendas'

const TiendasOficiales = (props) => {
  const [buscar, setBuscar] = useState('')
  const { isAuthenticated } = useContext(LoginContext)

  const handleBuscar = async (buscar) => {
    setBuscar(buscar)
  }

  const mostrarMensaje = () => {
    return (
      <div>
        <MensajeConexion />
        <Login {...props} />
      </div>
    )
  }

  if (!isAuthenticated) {
    return mostrarMensaje()
  } else {
    return (
      <>
        <MenuFiltros
          idComponente={15}
          onBuscar={handleBuscar}
          placeholder={'Buscar Tienda'}
          titulo="Tiendas Oficiales"
          ocultarMenu
        />
        <ContenedorTiendas buscar={buscar} />
      </>
    )
  }
}

export default TiendasOficiales
